import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getWarehouseGraphData, getWarehouseReport, getWarehouseTableData } from "../api/boWarehouse";

export const fetchTableData = createAsyncThunk(
  "boWarehouse/fetchTableData",
  async (params) =>
    getWarehouseTableData(
      params?.aggr,
      params?.division,
      params?.department,
      params?.vendor,
      params?.location,
      params?.page,
      params?.limit,
      params?.sort_column,
      params?.sort_order
    )
);

export const fetchGraphData = createAsyncThunk(
    "boWarehouse/fetchGraphData",
    async (params) =>
      getWarehouseGraphData(
        params?.division,
        params?.department,
        params?.vendor,
        params?.location
      )
  );

  export const fetchWarehouseReport = createAsyncThunk(
    "boWarehouse/fetchWarehouseReport",
    async (params) =>
      getWarehouseReport(
        params?.division,
        params?.department,
        params?.vendor,
        params?.location
      )
  );

export const boWarehouseSlice = createSlice({
  name: "boWarehouse",
  initialState: {
    tableData: null,
    graphData: null,
    warehouseReport: null,
    loading: false
  },
  extraReducers: {
    [fetchTableData.pending]: (state, {payload}) => {
        state.loading = true;
    },
    [fetchTableData.fulfilled]: (state, {payload}) => {
        state.tableData = payload;
        state.loading = false;
    },
    [fetchTableData.rejected]: (state, {payload}) => {
        state.loading = false;
    },
    // [fetchGraphData.pending]: (state, {payload}) => {
    //     state.loading = true;
    // },
    [fetchGraphData.fulfilled]: (state, {payload}) => {
        state.graphData = payload;
        // state.loading = false;
    },
    // [fetchGraphData.rejected]: (state, {payload}) => {
    //     state.loading = false;
    // },
    [fetchWarehouseReport.pending]: (state, {payload}) => {
        state.loading = true;
    },
    [fetchWarehouseReport.fulfilled]: (state, {payload}) => {
        state.warehouseReport = payload;
        state.loading = false;
    },
    [fetchWarehouseReport.rejected]: (state, {payload}) => {
        state.loading = false;
    }
  },
});

export default boWarehouseSlice.reducer;
